<template>
  <div class="rocket-callback-wrapper">
    <div class="callback-container">
      <!-- Loading State -->
      <div v-if="isProcessing" class="processing-state">
        <div class="loader-wrapper">
          <div class="payment-loader">
            <div class="spinner"></div>
          </div>
          <h3 class="processing-title">Processing Payment</h3>
          <p class="processing-text">Please wait while we verify your payment...</p>
          <p class="processing-subtext">Do not close this window or press the back button.</p>
        </div>
      </div>

      <!-- Success State -->
      <div v-if="paymentSuccess" class="success-state">
        <div class="success-wrapper">
          <div class="success-icon">
            <i class="fa fa-check-circle"></i>
          </div>
          <h2 class="success-title">Payment Successful!</h2>
          <p class="success-message">Your payment has been processed successfully.</p>

          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">Bill Number:</span>
              <span class="detail-value">{{ paymentData.bill }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Amount:</span>
              <span class="detail-value">{{ paymentData.amount }} BDT</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Transaction ID:</span>
              <span class="detail-value">{{ paymentData.txn_id }}</span>
            </div>
            <div class="detail-row" v-if="paymentData.approval">
              <span class="detail-label">Approval Code:</span>
              <span class="detail-value">{{ paymentData.approval }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Payment Date:</span>
              <span class="detail-value">{{ paymentData.paid_at }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Unit:</span>
              <span class="detail-value">{{ paymentData.unit }}</span>
            </div>
          </div>

          <div class="action-buttons">
            <!-- <button @click="downloadReceipt" class="btn btn-primary btn-lg">
              <i class="fa fa-download"></i> Download Receipt
            </button> -->
            <button 
                                    class="btn info-btn btn-info radius-1 align-items-center" 
                                    @click="downloadPaySlip({
                                      unit:paymentData.unit,
                                      bill_status:'confirmed',
                                      application_status:paymentData.approval,
                                      bill_number:paymentData.bill,
                                      agent:'rocket',
                                      amount:paymentData.amount,
                                      paid_at:paymentData.paid_at
                                    })"
                                    :disabled="downloadingBills[paymentData.bill]"
                                    type="button"
                                  >
                                    <!-- Icon -->
                                    <i 
                                      :class="downloadingBills[paymentData.bill] ? 'fa fa-spinner fa-spin' : 'fa fa-download'" 
                                      aria-hidden="true"
                                      style="font-size: 1.2em; margin-right: 8px;"
                                    ></i>

                                    <!-- Text -->
                                    <span style="font-size: 0.85rem;">
                                      {{ downloadingBills[paymentData.bill] ? paySlipProgresse : 'Download Payment Receipt' }}
                                    </span>
                                  </button>

            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-user"></i> Go to Profile
            </button>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div v-if="paymentError" class="error-state">
        <div class="error-wrapper">
          <div class="error-icon">
            <i class="fa fa-times-circle"></i>
          </div>
          <h2 class="error-title">Payment Failed</h2>
          <p class="error-message">Unfortunately, your payment could not be completed.</p>

          <div class="error-details">
            <div class="alert alert-danger">
              <strong>Error Reason:</strong><br>
              {{ errorData.reason }}
            </div>
          </div>

          <div class="help-text">
            <h5>What to do next:</h5>
            <ul>
              <li>Please try again after some time</li>
              <li>Ensure you have sufficient balance in your account</li>
              <li>Check if you completed the payment on the gateway</li>
              <li>If the problem persists, contact the helpdesk with the error details above</li>
            </ul>
          </div>

          <div class="action-buttons">
           <!--  <button @click="retryPayment" class="btn btn-primary btn-lg">
              <i class="fa fa-refresh"></i> Try Again
            </button> -->
            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-arrow-left"></i> Back to Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET } from '../../utils/GCERequest'
import { generateReceipt, prepareReceiptDataFromLegacy, RECEIPT_PRESETS } from '../../utils/ReceiptGenerator'
import PayslipGenerator from '@/utils/PayslipGenerator'

export default {
  name: 'GCERocketCallback',
  data() {
    return {
      isProcessing: true,
      paymentSuccess: false,
      paymentError: false,
      paymentData: {
        bill: '',
        amount: '',
        txn_id: '',
        approval: '',
        paid_at: '',
        unit: '',
        student_name: '',
        father_name: '',
        user_id: ''
      },
      errorData: {
        reason: '',
        code: ''
      },
      transactionId: '',
      callbackToken: '',
      status: '',
      isDownloadingPaySlip: false,
      paySlipProgresse: 'Preparing...',
      downloadingBills: {}
    }
  },
  computed: {
    gceToken() {
      return this.$root.$store.getters.getGceToken
    },
    gceUser() {
      return this.$root.$store.getters.getGceUser
    }
  },
  mounted() {
    this.processCallback()
  },
  methods: {
    async downloadPaySlip(paymentReceipe) {

      const billNumber = paymentReceipe.bill_number

      // Skip if already downloading
      if (this.downloadingBills[billNumber]) return
      // if (this.isDownloadingPaySlip) {
      //   return
      // }

      //this.isDownloadingPaySlip = true
      this.$set(this.downloadingBills, billNumber, true)
      this.paySlipProgresse = 'Preparing...'

      try {
        await PayslipGenerator.generatePayslip(
          {            
            name:this.paymentData.student_name,
            father_name:this.paymentData.father_name,
            userID:this.paymentData.user_id
          },
          paymentReceipe,
          'PAID',
          (message, progress) => {
            this.paySlipProgresse = message
          },
          (error) => {
            console.error('Payment Receipet generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Payment Receipet. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Payment Receipet downloaded successfully!'
        })
      } catch (error) {
        console.error('Payment Receipet download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Payment Receipet. Please try again.'
        })
      } finally {
        //this.isDownloadingPaySlip = false
        this.$set(this.downloadingBills, billNumber, false)
        this.paySlipProgresse = 'Preparing...'
      }
    },
    async processCallback() {
      try {
        // Get parameters from URL
        const urlParams = new URLSearchParams(window.location.search)
        this.callbackToken = urlParams.get('token') || ''
        this.status = urlParams.get('status') || ''
        const errorCode = urlParams.get('code') || ''

        // Check for error status from backend
        if (this.status === 'error') {
          const errorMessages = {
            'MISSING_TXN_ID': 'Transaction ID is missing. Please try again.',
            'INVALID_TXN_ID': 'Invalid transaction. Please contact support.',
            'SYSTEM_ERROR': 'A system error occurred. Please try again later.'
          }
          const errorReason = errorMessages[errorCode] || 'Payment processing failed'
          this.showError(errorReason, errorCode)
          return
        }

        // Validate callback token
        if (!this.callbackToken) {
          this.showError('Invalid callback session. Please try again.', 'MISSING_TOKEN')
          return
        }

        // Retrieve callback data using secure token
        await this.retrieveCallbackData()

      } catch (error) {
        console.error('Callback processing error:', error)
        this.showError('An unexpected error occurred while processing your payment', 'CALLBACK_ERROR')
      }
    },

    async retrieveCallbackData() {
      try {
        // Call backend API to retrieve callback data
        const response = await GET(`/api/service/dbbl/gce/callback-data?token=${this.callbackToken}`)

        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          // Store transaction ID from callback data
          this.transactionId = data.transaction_id

          // Now verify the payment with backend
          await this.verifyPayment()

        } else {
          this.showError('Unable to retrieve payment information. Session may have expired.', 'RETRIEVE_FAILED')
        }

      } catch (error) {
        console.error('Callback data retrieval error:', error)

        if (error.response && error.response.data) {
          const errorMsg = error.response.data.error || 'Unable to retrieve payment information'
          const errorCode = error.response.data.error_code || 'RETRIEVE_ERROR'
          this.showError(errorMsg, errorCode)
        } else {
          this.showError('Network error. Unable to retrieve payment information.', 'NETWORK_ERROR')
        }
      }
    },

    async verifyPayment() {
      try {
        // Call backend API to verify and complete payment
        const response = await GET(`/api/service/dbbl/gce/verify-payment?trans_id=${this.transactionId}`)
        
        console.log('Verify Payment Response:', response)

        if (response.status === 200) {
          const data = response.data

          if (data.success && data.payment_successful) {
            // Payment successful - populate payment data
            this.paymentData = {
              bill: data.bill_number || '',
              amount: data.amount || '',
              txn_id: data.transaction_id || this.transactionId,
              approval: data.approval_code || '',
              paid_at: data.paid_at || new Date().toLocaleString(),
              unit: 'GCE',
              student_name: data.student_name || '',
              father_name: data.father_name || '',
              user_id: data.application_id || ''
            }

            this.paymentSuccess = true
            this.isProcessing = false

          } else {
            // Payment failed
            const errorMsg = data.message || data.error || 'Payment verification failed'
            this.showError(errorMsg, data.error_code || 'PAYMENT_FAILED')
          }
        } else {
          this.showError('Unable to verify payment. Please contact helpdesk.', 'VERIFY_FAILED')
        }

      } catch (error) {
        console.error('Payment verification error:', error)

        if (error.response && error.response.data) {
          const errorMsg = error.response.data.message || error.response.data.error || 'Payment verification failed'
          const errorCode = error.response.data.error_code || ''
          this.showError(errorMsg, errorCode)
        } else {
          this.showError('Network error. Unable to verify payment. Please check your connection.', 'NETWORK_ERROR')
        }
      }
    },

    showError(reason, code = '') {
      this.isProcessing = false
      this.paymentError = true
      this.errorData.reason = reason
      this.errorData.code = code
      console.error('Payment error:', { reason, code })
    },

    async downloadReceipt() {
      try {
        const receiptData = prepareReceiptDataFromLegacy({
          name: this.paymentData.student_name,
          father_name: this.paymentData.father_name,
          userID: this.paymentData.user_id,
          bill_number: this.paymentData.bill,
          amount: this.paymentData.amount,
          txn_id: this.paymentData.txn_id,
          approval: this.paymentData.approval,
          paid_at: this.paymentData.paid_at,
          unit: 'GCE',
          agent: 'DBBL Rocket',
          status: 'PAID'
        })

        await generateReceipt(
          receiptData,
          RECEIPT_PRESETS.ROCKET,
          `cu_gce_payment_receipt_rocket_${this.paymentData.bill}.pdf`
        )

      } catch (error) {
        console.error('Error generating receipt:', error)
        alert('Failed to generate receipt. Please try again.')
      }
    },

    retryPayment() {
      this.$router.push('/gce/dashboard')
    },

    goToProfile() {
      this.$router.push('/gce/dashboard')
    }
  }
}
</script>

<style scoped>
.rocket-callback-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.callback-container {
  width: 100%;
  max-width: 750px;
}

/* Loading State */
.processing-state {
  background: white;
  border-radius: 20px;
  padding: 60px 50px;
  text-align: center;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
}

.loader-wrapper {
  max-width: 400px;
  margin: 0 auto;
}

.payment-loader {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}

.spinner {
  width: 80px;
  height: 80px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.processing-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  margin-top: 0;
}

.processing-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.processing-subtext {
  font-size: 14px;
  color: #999;
  font-style: italic;
}

/* Success State */
.success-state {
  background: white;
  border-radius: 20px;
  padding: 50px 45px;
  text-align: center;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
}

.success-wrapper {
  max-width: 600px;
  margin: 0 auto;
}

.success-icon {
  margin-bottom: 25px;
}

.success-icon i {
  font-size: 80px;
  color: #28a745;
}

.success-title {
  font-size: 32px;
  font-weight: 700;
  color: #28a745;
  margin-bottom: 12px;
  margin-top: 0;
}

.success-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 35px;
}

.payment-details {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 35px;
  text-align: left;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 600;
  color: #555;
  font-size: 15px;
}

.detail-value {
  font-weight: 500;
  color: #333;
  text-align: right;
  font-size: 15px;
}

/* Error State */
.error-state {
  background: white;
  border-radius: 20px;
  padding: 50px 45px;
  text-align: center;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
}

.error-wrapper {
  max-width: 600px;
  margin: 0 auto;
}

.error-icon {
  margin-bottom: 25px;
}

.error-icon i {
  font-size: 80px;
  color: #dc3545;
}

.error-title {
  font-size: 32px;
  font-weight: 700;
  color: #dc3545;
  margin-bottom: 12px;
  margin-top: 0;
}

.error-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}

.error-details {
  margin-bottom: 30px;
}

.error-details .alert {
  padding: 20px;
  border-radius: 10px;
  text-align: left;
  font-size: 15px;
  line-height: 1.6;
}

.help-text {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px 30px;
  margin-bottom: 35px;
  text-align: left;
}

.help-text h5 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.help-text ul {
  margin: 0;
  padding-left: 20px;
}

.help-text li {
  margin-bottom: 10px;
  color: #555;
  font-size: 14px;
  line-height: 1.5;
}

.help-text li:last-child {
  margin-bottom: 0;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;
}

.action-buttons .btn {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.action-buttons .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.action-buttons .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.action-buttons .btn-info {
  background: #17a2b8;
  color: white;
}

.action-buttons .btn-info:hover:not(:disabled) {
  background: #138496;
}

.action-buttons .btn-secondary {
  background: #6c757d;
  color: white;
}

.action-buttons .btn-secondary:hover {
  background: #5a6268;
}

/* Responsive Design */
@media (max-width: 768px) {
  .processing-state, .success-state, .error-state {
    padding: 35px 25px;
    border-radius: 15px;
  }

  .spinner {
    width: 60px;
    height: 60px;
    border-width: 6px;
  }

  .processing-title, .success-title, .error-title {
    font-size: 24px;
  }

  .success-icon i, .error-icon i {
    font-size: 60px;
  }

  .payment-details {
    padding: 20px;
  }

  .detail-row {
    flex-direction: column;
    gap: 5px;
    padding: 10px 0;
  }

  .detail-value {
    text-align: left;
  }

  .help-text {
    padding: 20px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 12px;
  }

  .action-buttons .btn {
    width: 100%;
    justify-content: center;
    padding: 12px 24px;
  }
}

@media (max-width: 480px) {
  .rocket-callback-wrapper {
    padding: 15px;
  }

  .processing-state, .success-state, .error-state {
    padding: 30px 20px;
  }

  .processing-title, .success-title, .error-title {
    font-size: 22px;
  }

  .payment-details {
    padding: 15px;
  }

  .detail-label, .detail-value {
    font-size: 14px;
  }
}
</style>
